import { TagNotFound } from '../errors';
import { getMfsTagTypeguard } from '../validation/typeGuard/folderInternalTypeGuard';
import { MFS_TAG_TYPE } from './constant/constants';
import { taggedRelationship } from './constant/internalRelationships';
import { getMfsItem } from './utils';
/** Converts an MfsTag object to a Tag type object. */
export function toTag(mfsTag) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { type, label, labelId, displayText, id, origin, secondaryLabels, kind, ...theRest } = mfsTag;
    const tag = {
        ...theRest,
        uniqueId: id,
    };
    return tag;
}
/** Util function for getting MfsTags. Separate from getMfsItem because the tag is identified by MFS id. */
export function getMfsTag(dataStore, tagId) {
    return dataStore.getItem(tagId, getMfsTagTypeguard());
}
/** Util function for getting MfsTags. Separate from getMfsItem because the tag is identified by MFS id. */
export function getMfsTagByValue(dataStore, tagValue) {
    return getMfsItem(dataStore, sanitizeTagValueForId(tagValue), MFS_TAG_TYPE);
}
/**
 * Util function for getting MfsTags and throwing error if it does not exist.
 * Separate from getMfsItem because the tagValue gets sanatized.
 */
export function getMfsTagOrThrowError(dataStore, tagId) {
    const mfsTag = getMfsTag(dataStore, tagId);
    if (!mfsTag) {
        throw new TagNotFound(`Unable to find target Tag.`);
    }
    return mfsTag;
}
/** Get all the Tags associated with an item. */
export function getTags(mfsItemId, dataStore) {
    const tags = [];
    for (const mfsItem of dataStore.getRelatedItems(mfsItemId, taggedRelationship)) {
        tags.push(toTag(mfsItem));
    }
    return tags;
}
/** Sanatizes the Tag value removing empty spaces */
export function sanitizeTagValue(tagValue) {
    return tagValue.trim();
}
/**
 * Applies some sanatition to a tag value to convert it into a tag labelId.
 * Do not do this with Cards since URIs could be case sensitive.
 */
export function sanitizeTagValueForId(tagValue) {
    return tagValue.toUpperCase().trim();
}
//# sourceMappingURL=taggingUtils.js.map